import { EditOutlined } from "@ant-design/icons";
import { Modal, Table, Button, Space, Tooltip, Typography, Grid } from "antd";

const { Text } = Typography;

const ManageAuthorsModal = ({
  open,
  onClose,
  authors,
  onEditAuthor,
}) => {
  const screens = Grid.useBreakpoint();
  const isMobileView = screens.md === false;

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 300,
      ellipsis: { showTitle: false },
      render: (authorName) => (
        <Tooltip placement="topLeft" title={authorName}>
          <Text strong>{authorName}</Text>
        </Tooltip>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 150,
      render: (authorType) => {
        if (!authorType) {
          return "Unknown";
        }
        return authorType
          .split("_")
          .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
          .join(" ");
      }
    },
    {
      title: "Codeforces Handle",
      dataIndex: "codeforcesHandle",
      key: "codeforcesHandle",
      width: 180,
      ellipsis: true,
    },
    {
      title: "Action",
      key: "action",
      width: 110,
      fixed: isMobileView ? undefined : "right",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => onEditAuthor(record)}
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Modal
      open={open}
      title="Manage Authors"
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <Table
        dataSource={authors}
        columns={columns}
        rowKey="_id"
        pagination={{ pageSize: 10 }}
        // Fixed total width so a long author name cannot stretch the table past the modal
        scroll={{ x: 740 }}
      />
    </Modal>
  );
};

export default ManageAuthorsModal;
